import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common/common';
import goodsStore from './modules/goodsStore/goodsStore';
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    common,
    goodsStore, // 商品模块状态管理
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js